/// <reference types="vite-plugin-svgr/client" />
import { useState, ReactElement, ReactNode } from 'react';
import { Link } from 'react-router';
import styles from './forgot-password.page.module.scss';
import { ForgotPassword, ForgotPasswordSuccess } from '@/me/components';
import { UICard, UISpacer, UIText } from '@/ui';
import { RegionSelector } from '@/common/components';
import SafepointLogo from '@/common/assets/images/safepoint-logo-dark.svg?react';
import { Trans } from 'react-i18next';

export function ForgotPasswordPage(): ReactElement {
    const [submittedEmail, setSubmittedEmail] = useState('');
    const [hasSuccessfullyReset, setHasSuccessfullyReset] = useState(false);

    return (
        <div className={styles.page}>
            <SafepointLogo width={300} />
            <UISpacer multiplier={4} />
            {hasSuccessfullyReset ? (
                <UICard className={styles.card}>
                    <ForgotPasswordSuccess
                        onResend={() => {
                            setHasSuccessfullyReset(false);
                        }}
                    />
                </UICard>
            ) : (
                <UICard className={styles.card}>
                    <ForgotPassword
                        defaultEmail={submittedEmail}
                        onSuccess={(data) => {
                            setHasSuccessfullyReset(true);
                            setSubmittedEmail(data.email);
                        }}
                    />
                </UICard>
            )}
            <UISpacer multiplier={1} />
            <RegionSelector variant="compact" />
            <UISpacer multiplier={2} />

            <UIText variant="basic">
                <Trans
                    ns="me"
                    i18nKey="shared.account.dont_have_an_account"
                    components={{ a: <SignUpLink /> }}
                />
            </UIText>
        </div>
    );
}

/**
 * The link inside the account prompt. Wrapping it in a component lets the whole
 * sentence be one translated string, so a language can order it as it needs.
 */
function SignUpLink({ children }: { children?: ReactNode }): ReactElement {
    return (
        <Link to={'/signup'} style={{ textDecoration: 'none' }}>
            <UIText variant="basic" type="link" underlineOnHover>
                {children}
            </UIText>
        </Link>
    );
}
